/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';

import RouteNames from '../../appAuthorized/RouteNames';
import AuthorizedRouteNames from '../../appAuthorized/RouteNames';
import ContentFrame from '../../applicationFrame/ContentFrame';
import { Button } from '../../components/buttons/Buttons';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../components/appNav/AppHeaderScrollable';
import Card, { CardSection } from '../../components/card/Card';
import tokenTypes from '../../../constants/tokenTypes';
import AppUtils from '../../../utilities/AppUtils';
import { isMobileApplication } from '../../../utilities/MobileUtil';

import ContentWrapper from '../../components/ContentWrapper';

function getTokenMessage(tokenType) {
  switch (tokenType) {
    case tokenTypes.forgotPassword:
      return {
        message: 'tokenExpiry.resetPwd.expiry.message.text',
        resolutionMessage: 'tokenExpiry.resetPwd.resolution.button.label',
        resolveActionUrl: RouteNames.forgotPassword(),
      };
    case tokenTypes.changeEmail:
      return {
        message: 'tokenExpiry.changeEmail.expiry.message.text',
        resolutionMessage: 'tokenExpiry.changeEmail.resolution.button.label',
        resolveActionUrl: RouteNames.home(),
      };
    case tokenTypes.verifyEmail:
      return {
        message: 'tokenExpiry.changeEmail.expiry.message.text',
        resolutionMessage: 'tokenExpiry.changeEmail.resolution.button.label',
        resolveActionUrl: RouteNames.home(),
      };
    default:
      return {
        message: 'tokenExpiry.verifyEmail.expiry.message.text',
        resolutionMessage: 'tokenExpiry.verifyEmail.resolution.button.label',
        resolveActionUrl: RouteNames.home(),
      };
  }
}

class ExpiredToken extends React.Component {

  constructor(props) {
    super(props);

    this.performResolveAction = this.performResolveAction.bind(this);

    this.state = {
      tryResolveAction: false,
    };
  }

  performLoggedInResolveAction() {
    if (isMobileApplication()) {
      AppUtils.reloadApp();
    } else {
      AppUtils.reloadAppToPathname(AuthorizedRouteNames.accountSettings());
    }
  }

  performResolveAction() {
    if (AppUtils.hasSessionToken()) {
      this.performLoggedInResolveAction();
    } else {
      this.setState({ tryResolveAction: true });
    }
  }

  render() {
    const expiredData = getTokenMessage(this.props.tokenType);
    const titleId = 'tokenExpiry.title.text';

    if (this.state.tryResolveAction) {
      return <Redirect to={expiredData.resolveActionUrl} />;
    } else {
      return (
        <div className="cmp-expired-token">
          <ScrollAwareContext>
            <ScrollAwareAppNavStep
              cancel={() => { AppUtils.reloadApp(); }}
              color="white"
            />

            <ContentFrame>
              <ScrollAwareScroller>
                <AppHeaderScrollableText id={titleId} />

                <ContentWrapper>
                  <Card
                    hasDropshadow
                  >
                    <CardSection
                      className="font-body"
                      hasBorder={false}
                      style={{ padding: '18px 16px' }}
                    >
                      <FormattedMessage id={expiredData.message} />
                    </CardSection>
                  </Card>

                  <div className="button font-body">
                    <Button
                      action="profile"
                      onClick={this.performResolveAction}
                      size="wide"
                    >
                      <FormattedMessage id={expiredData.resolutionMessage} />
                    </Button>
                  </div>
                </ContentWrapper>

              </ScrollAwareScroller>
            </ContentFrame>
          </ScrollAwareContext>
        </div>
      );
    }
  }
}
ExpiredToken.propTypes = {
  tokenType: PropTypes.string.isRequired,
};

export default ExpiredToken;
